// extracted by mini-css-extract-plugin
export default {"container":"ClientDataMapping_container__tVWtq","editedCell":"ClientDataMapping_editedCell__mAWf8"};